import Vue from 'vue';
import Vuex from 'vuex';

import catalog from './vuex/catalog';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    catalog,
  },
  // enable strict mode (adds overhead!)
  // for dev mode only
  strict: process.env.DEV,
});
